import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Center, Spinner } from '@chakra-ui/react';
import { getStoredAuth, isTokenValid } from '@/lib/auth';

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard = ({ children }: AuthGuardProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const auth = getStoredAuth();

    if (!auth?.token || !isTokenValid(auth.token)) {
      // Store the attempted URL to redirect after login
      const returnUrl = location.pathname + location.search;
      navigate(`/admin/login?returnUrl=${encodeURIComponent(returnUrl)}`);
    } else {
      setIsChecking(false);
    }
  }, [location, navigate]);

  if (isChecking) {
    return (
      <Center h="100vh">
        <Spinner size="xl" color="purple.500" thickness="4px" />
      </Center>
    );
  }

  return <>{children}</>;
};

export default AuthGuard;